import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useIdentitySheet } from '../features/auth/identity-sheet';

/**
 * /onboarding — 깊은 링크. 마이페이지로 가면서 「정체성 정하기」 슬라이드 창을 연다.
 * 질문은 페이지가 아니라 창에서 진행된다(§identity-sheet).
 */
export const Route = createFileRoute('/onboarding')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  component: OnboardingRedirect,
});

function OnboardingRedirect() {
  const { open } = useIdentitySheet();
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: '/mypage', replace: true });
    open();
  }, [navigate, open]);
  return null;
}
